import { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";

import { Button } from "@mantine/core";
import { Calendar, DateInput } from "@mantine/dates";
import Chart_Bar_CafePOS_3_2_2 from "../Chart/Chart_Bar_CafePOS_3_2_2";

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const Comp_Cafe_POS_HeatMap_Daily_ByZone = ({ selectedPresentationCafe }) => {
  const [DB_CafeZoneList, setDB_CafeZoneList] = useState([]);
  const get_DB_CafeZoneList_ByCafe = async (cafe) => {
    setLoadTask1(0);
    console.log("load task 1 start");

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/get_awesome_pos__zonelistdata__bycafe`, {
        cafe,
      })
      .then((res) => {
        console.log("get_awesome_pos__zonelistdata__bycafe", res?.data);

        setDB_CafeZoneList(res?.data);
        setLoadTask1(1);
        // console.log("load task 1 done");
      });
  };

  //----------------------------------- global variable
  //   const [selectedPresentationCafe, setSelectedPresentationCafe] = useState(
  //     _selectedPresentationCafe
  //   );
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const [load_1, setLoad_1] = useState(true);
  const [load_2, setLoad_2] = useState(false);
  const [load_3, setLoad_3] = useState(false);
  const [load_4, setLoad_4] = useState(false);
  const [load_5, setLoad_5] = useState(false);

  const [loadTask1, setLoadTask1] = useState(1);
  const [loadTask2, setLoadTask2] = useState(0);

  const [selectedPresentationMode, setSelectedPresentationMode] = useState("");
  const [calenderValue, setCalenderValue] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  //----------------------------------- function
  function forwardOneMonth() {
    setCalenderValue((prev) => dayjs(prev).add(1, "month").toDate());
    setSelectedDay((prev) => dayjs(prev).add(1, "month").format("YYYY-MM-DD"));
  }

  function backOneMonth() {
    setCalenderValue((prev) => dayjs(prev).subtract(1, "month").toDate());
    setSelectedDay((prev) =>
      dayjs(prev).subtract(1, "month").format("YYYY-MM-DD")
    );
  }

  function getDaysInMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed

    // Get the number of days in the month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Create array of days ['1', '2', ..., '31']
    const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
      (i + 1).toString()
    );

    return daysArray;
  }

  function getDayOfWeek(_dateString_YYMM, _DD) {
    let actualDate = _dateString_YYMM.slice(0, 7) + "-" + _DD.padStart(2, "0");

    function getDayTitle(dateString) {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const date = new Date(dateString);
      return days[date.getDay()];
    }

    return getDayTitle(actualDate);
  }

  const COMP_ShowAllDaysInMonth = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",

            // backgroundColor: stringToColor(pczoneSelected),
            gap: 10,
          }}
        >
          <div
            style={{
              width: "160px",
              minWidth: "160px",
              fontSize: 10,
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              marginLeft: 10,
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              width: "70px",
              minWidth: "70px",
              fontSize: 15,
              textAlign: "right",
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 0,
              width: "1400px",
              minWidth: "1400px",
            }}
          >
            {getDaysInMonth(selectedDay)?.map((x, i) => {
              return (
                <div
                  key={i}
                  style={{
                    marginLeft: "0.1rem",
                    marginBottom: "0.1rem",
                    backgroundColor: "white",
                    color: "black",
                    width: "30px",
                  }}
                >
                  <div>{x}</div>
                  <div
                    style={{
                      fontSize: 10,
                      color:
                        getDayOfWeek(selectedDay, x) === "Sun"
                          ? "red"
                          : "black",
                    }}
                  >
                    {getDayOfWeek(selectedDay, x)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <div>3.2. Group By PC Zone (measure by time)</div>
      <h2>3.2.2Daily </h2>
      <div
        style={{
          backgroundColor: "white",
          padding: "1rem",
          borderRadius: "1rem",
          // position: "sticky",
          // top: 35,
          // zIndex: 10,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <Button
            disabled={loadTask1 == 0}
            color="dark"
            onClick={() => {
              backOneMonth();
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Previous Month
          </Button>
          <Button
            disabled={loadTask1 == 0}
            color="dark"
            onClick={() => {
              forwardOneMonth();
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Next Month
          </Button>
          <div style={{ color: "black" }}>
            <b>Pick a Month</b>
          </div>
          <div>
            <DateInput
              clearable={false}
              disabled={loadTask1 == 0}
              value={calenderValue}
              onChange={(e) => {
                setSelectedDay(dayjs(e).format("YYYY-MM-DD"));
                return setCalenderValue(e);
              }}
            />
          </div>
          <Button
            color="lime"
            onClick={() => {
              get_DB_CafeZoneList_ByCafe(selectedPresentationCafe);
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Check Daily This Month
          </Button>
          {/* <div
                            style={{ color: "black" }}
                          >{`selectedDay:${selectedDay}`}</div> */}
          <div style={{ color: "black" }}>
            {`Total PCs : ${DB_CafeZoneList?.length}, cafe : ${selectedPresentationCafe},`}
          </div>
          <div style={{ color: "black" }}>
            {loadTask1 == 0 ? (
              <div style={{ color: "orange" }}>Loading...</div>
            ) : (
              <div style={{ color: "green" }}>
                {`Data Loaded = ${loadTask1 * 100}%`}
              </div>
            )}
          </div>
        </div>
      </div>
      <br />
      {DB_CafeZoneList?.length > 0 ? (
        <>
          <h2>PC Daily Occupency Rate % - By ZONE</h2>
          <Button
            color="lime"
            variant={showMoreInfo ? "filled" : "subtle"}
            onClick={() => {
              setShowMoreInfo(!showMoreInfo);
            }}
          >
            Show extra info
          </Button>
          <br />
          <br />
          {/* list all days in this month  */}
          <COMP_ShowAllDaysInMonth />
          {load_1 == true ? (
            DB_CafeZoneList?.slice(0, 30)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_2_2
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pczoneSelected={`${x?.pczone_name} - (${x?.dlip}) ${x?.total_pc}pc`}
                  total_pc={x?.total_pc}
                  zone={x?.dlip}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_1 == true}
              onClick={() => {
                setLoad_1(true);
              }}
            >
              Load part 1
            </Button>
          )}
          {load_2 == true ? (
            DB_CafeZoneList?.slice(30, 60)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_2_2
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pczoneSelected={`${x?.pczone_name} - (${x?.dlip}) ${x?.total_pc}pc`}
                  total_pc={x?.total_pc}
                  zone={x?.dlip}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_2 == true}
              onClick={() => {
                setLoad_2(true);
              }}
            >
              Load part 2
            </Button>
          )}
          {load_3 == true ? (
            DB_CafeZoneList?.slice(60, 90)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_2_2
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pczoneSelected={`${x?.pczone_name} - (${x?.dlip}) ${x?.total_pc}pc`}
                  total_pc={x?.total_pc}
                  zone={x?.dlip}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_3 == true}
              onClick={() => {
                setLoad_3(true);
              }}
            >
              Load part 3
            </Button>
          )}
          {load_4 == true ? (
            DB_CafeZoneList?.slice(90, 120)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_2_2
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pczoneSelected={`${x?.pczone_name} - (${x?.dlip}) ${x?.total_pc}pc`}
                  total_pc={x?.total_pc}
                  zone={x?.dlip}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_4 == true}
              onClick={() => {
                setLoad_4(true);
              }}
            >
              Load part 4
            </Button>
          )}
          {load_5 == true ? (
            DB_CafeZoneList?.slice(120, 150)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_2_2
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pczoneSelected={`${x?.pczone_name} - (${x?.dlip}) ${x?.total_pc}pc`}
                  total_pc={x?.total_pc}
                  zone={x?.dlip}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_5 == true}
              onClick={() => {
                setLoad_5(true);
              }}
            >
              Load part 5
            </Button>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Comp_Cafe_POS_HeatMap_Daily_ByZone;
